const API_URL = import.meta.env.VITE_API_URL || '';

export interface PublicPageDetails {
  branchName: string;
  logoUrl: string | null;
  primaryColor: string | null;
  backgroundColor: string | null;
  textColor: string | null;
  promoText: string | null;
  promoActive: boolean;
  configuredSegments: string[];

  /* O que a página escreve e o que ela pergunta, decidido na configuração.
     Opcionais no tipo porque a API pode ser mais antiga que este front — cada
     leitor trata a ausência com o mesmo padrão de antes. */
  headline?: string | null;
  subheadline?: string | null;
  askSegment?: boolean;
  askEmail?: boolean;
  askCity?: boolean;
  thanksMessage?: string | null;
}

/* Os seis campos de endereço saíram: o formulário não os pede desde que a seção
   de endereço foi cortada, e o front vinha mandando `undefined` em todos. Eles
   chegavam ao controller como null e eram atribuídos sem condição — um segundo
   cadastro pelo QR apagava o endereço que o contato já tinha. O conserto do lado
   da API é a fase 4; aqui é só parar de mandar o que ninguém preenche. */
export interface RegisterContactDTO {
  nome: string;
  telefone: string;
  email?: string;
  segment?: string;
  city?: string;
}

export interface PromoResult {
  promoCode: string | null;
  promoText: string | null;
  promoActive: boolean;
}

const PublicLandingPageService = {
  getPageDetails: async (token: string): Promise<PublicPageDetails> => {
    const res = await fetch(`${API_URL}/api/public/landing-page/${token}`);
    const data = await res.json();
    if (!data.sucesso) throw new Error(data.mensagem);
    return data.dados;
  },

  registerContact: async (token: string, payload: RegisterContactDTO): Promise<PromoResult> => {
    const res = await fetch(`${API_URL}/api/public/landing-page/${token}/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    const data = await res.json();
    if (!data.sucesso) throw new Error(data.mensagem);
    return data.dados;
  }
};

export default PublicLandingPageService;
